// Question translations for Wedding-O-Mat
// IMPORTANT: 'value' fields MUST remain in German for backend compatibility
// Only 'label' fields are translated for display

export const questionTranslations = {
  de: {
    q1: {
      question: "In welchem Zeitraum planst du zu heiraten?",
      options: [
        { value: "Januar-Februar", label: "Januar - Februar" },
        { value: "März-April", label: "März - April" },
        { value: "Mai-Juni", label: "Mai - Juni" },
        { value: "Juli-August", label: "Juli - August" },
        { value: "September-Oktober", label: "September - Oktober" },
        { value: "November-Dezember", label: "November - Dezember" }
      ]
    },
    q2: {
      question: "Wie weit darf die Destination entfernt sein?",
      options: [
        { value: "1", label: "Nah (z.B. Europa)" },
        { value: "2", label: "Mittel (z.B. Naher Osten, Nordafrika)" },
        { value: "3", label: "Fern (z.B. Asien, Afrika)" },
        { value: "4", label: "Weit (z.B. Amerika, Ozeanien)" }
      ]
    },
    q3: {
      question: "Welche kulturellen Aspekte sind dir wichtig?",
      options: [
        { value: "Kulinarik & Wein", label: "Kulinarik & Wein" },
        { value: "Geschichte & Architektur", label: "Geschichte & Architektur" },
        { value: "Kunst & Design", label: "Kunst & Design" },
        { value: "Spiritualität", label: "Spiritualität" },
        { value: "Moderne Vibes", label: "Moderne Vibes" }
      ]
    },
    q4: {
      question: "Welches Klima bevorzugst du?",
      options: [
        { value: "tropisch & warm", label: "Tropisch & Warm" },
        { value: "mediterran & mild", label: "Mediterran & Mild" },
        { value: "gemäßigt & kühl", label: "Gemäßigt & Kühl" },
        { value: "trocken & sonnig", label: "Trocken & Sonnig" },
        { value: "alpin & polar", label: "Alpin & Polar" }
      ]
    },
    q5: {
      question: "Welches Szenario spricht dich am meisten an?",
      options: [
        { value: "Strand", label: "Strand" },
        { value: "Regenwald", label: "Regenwald" },
        { value: "Berge", label: "Berge" },
        { value: "City", label: "City" },
        { value: "Wüste", label: "Wüste" }
      ]
    },
    q6: {
      question: "Wie viele Gäste erwartest du?",
      options: [
        { value: "zu_zweit", label: "Nur zu zweit" },
        { value: "ca_15", label: "Ca. 15 Personen" },
        { value: "ca_25", label: "Ca. 25 Personen" },
        { value: "ca_40", label: "Ca. 40 Personen" },
        { value: "mehr_40", label: "Mehr als 40 Personen" }
      ]
    },
    q7: {
      question: "Wie viele Tage soll die Hochzeit dauern?",
      options: [
        { value: "1", label: "1 Tag" },
        { value: "2", label: "2 Tage" },
        { value: "3", label: "3 Tage" },
        { value: "4", label: "4+ Tage" }
      ]
    },
    q8: {
      question: "Was ist dein Budget-Bereich?",
      options: [
        { value: "20_40k", label: "20.000 - 40.000 €" },
        { value: "40_60k", label: "40.001 - 60.000 €" },
        { value: "60_80k", label: "60.001 - 80.000 €" },
        { value: "80_100k", label: "80.001 - 100.000 €" },
        { value: "100k_plus", label: "100.000 € +" }
      ]
    },
    q9: {
      question: "Welche Art der Zeremonie bevorzugst du?",
      options: [
        { value: "Freie_Trauung", label: "Freie Trauung" },
        { value: "Religiöse_Zeremonie", label: "Religiöse Zeremonie" },
        { value: "Standesamt", label: "Standesamt" },
        { value: "Symbolische_Zeremonie", label: "Symbolische Zeremonie" }
      ]
    },
    q10: {
      question: "Welcher Hochzeitsstil passt zu dir?",
      options: [
        { value: "Elegant", label: "Elegant" },
        { value: "Boho", label: "Boho" },
        { value: "Rustikal", label: "Rustikal" },
        { value: "Glamourös", label: "Glamourös" },
        { value: "Minimalistisch", label: "Minimalistisch" }
      ]
    },
    q11: {
      question: "Welches Ambiente wünschst du dir?",
      options: [
        { value: "Rustikal", label: "Rustikal" },
        { value: "Modern", label: "Modern" },
        { value: "Exotisch", label: "Exotisch" },
        { value: "Royal", label: "Royal" }
      ]
    },
    q12: {
      question: "Was ist dir bei der Location wichtig?",
      options: [
        { value: "Exklusiv", label: "Exklusivität" },
        { value: "Authentisch", label: "Authentizität" },
        { value: "Luxuriös", label: "Luxus" },
        { value: "Individuell", label: "Individualität" }
      ]
    },
    q13: {
      question: "Was ist dir bei der Unterkunft wichtig?",
      options: [
        { value: "Luxus", label: "Luxus" },
        { value: "Komfort", label: "Komfort" },
        { value: "Charme", label: "Charme" },
        { value: "Praktisch", label: "Praktisch" }
      ]
    },
    q14: {
      question: "Welche Art von Unterkunft bevorzugst du?",
      options: [
        { value: "Hotel", label: "Hotel" },
        { value: "Villa", label: "Villa" },
        { value: "Resort", label: "Resort" },
        { value: "Boutique", label: "Boutique" }
      ]
    },
    q15: {
      question: "Wo liegt neben der Trauung der Fokus am Hochzeitstag?",
      options: [
        { value: "Klassische_Feier", label: "Klassische Feier mit Dinner & Tanz" },
        { value: "Party_BBQ", label: "Party, Barbecue & Fingerfood" },
        { value: "Gala", label: "Gala-Dinner & Feuerwerk" },
        { value: "Intim", label: "Intime Feier & Solo-Musiker" }
      ]
    }
  },
  en: {
    q1: {
      question: "When are you planning to get married?",
      options: [
        { value: "Januar-Februar", label: "January - February" },
        { value: "März-April", label: "March - April" },
        { value: "Mai-Juni", label: "May - June" },
        { value: "Juli-August", label: "July - August" },
        { value: "September-Oktober", label: "September - October" },
        { value: "November-Dezember", label: "November - December" }
      ]
    },
    q2: {
      question: "How far are you willing to travel for your wedding?",
      options: [
        { value: "1", label: "Near (e.g., Europe)" },
        { value: "2", label: "Medium (e.g., Middle East, North Africa)" },
        { value: "3", label: "Far (e.g., Asia, Africa)" },
        { value: "4", label: "Very Far (e.g., Americas, Oceania)" }
      ]
    },
    q3: {
      question: "Which cultural aspects are important to you?",
      options: [
        { value: "Kulinarik & Wein", label: "Culinary & Wine" },
        { value: "Geschichte & Architektur", label: "History & Architecture" },
        { value: "Kunst & Design", label: "Art & Design" },
        { value: "Spiritualität", label: "Spirituality" },
        { value: "Moderne Vibes", label: "Modern Vibes" }
      ]
    },
    q4: {
      question: "Which climate do you prefer?",
      options: [
        { value: "tropisch & warm", label: "Tropical & Warm" },
        { value: "mediterran & mild", label: "Mediterranean & Mild" },
        { value: "gemäßigt & kühl", label: "Temperate & Cool" },
        { value: "trocken & sonnig", label: "Dry & Sunny" },
        { value: "alpin & polar", label: "Alpine & Polar" }
      ]
    },
    q5: {
      question: "Which scenario appeals to you most?",
      options: [
        { value: "Strand", label: "Beach" },
        { value: "Regenwald", label: "Rainforest" },
        { value: "Berge", label: "Mountains" },
        { value: "City", label: "City" },
        { value: "Wüste", label: "Desert" }
      ]
    },
    q6: {
      question: "How many guests do you expect?",
      options: [
        { value: "zu_zweit", label: "Just the two of us" },
        { value: "ca_15", label: "About 15 people" },
        { value: "ca_25", label: "About 25 people" },
        { value: "ca_40", label: "About 40 people" },
        { value: "mehr_40", label: "More than 40 people" }
      ]
    },
    q7: {
      question: "How many days should the wedding last?",
      options: [
        { value: "1", label: "1 Day" },
        { value: "2", label: "2 Days" },
        { value: "3", label: "3 Days" },
        { value: "4", label: "4+ Days" }
      ]
    },
    q8: {
      question: "What is your budget range?",
      options: [
        { value: "20_40k", label: "€20,000 - €40,000" },
        { value: "40_60k", label: "€40,001 - €60,000" },
        { value: "60_80k", label: "€60,001 - €80,000" },
        { value: "80_100k", label: "€80,001 - €100,000" },
        { value: "100k_plus", label: "€100,000 +" }
      ]
    },
    q9: {
      question: "What type of ceremony do you prefer?",
      options: [
        { value: "Freie_Trauung", label: "Free Ceremony" },
        { value: "Religiöse_Zeremonie", label: "Religious Ceremony" },
        { value: "Standesamt", label: "Civil Ceremony" },
        { value: "Symbolische_Zeremonie", label: "Symbolic Ceremony" }
      ]
    },
    q10: {
      question: "Which wedding style suits you?",
      options: [
        { value: "Elegant", label: "Elegant" },
        { value: "Boho", label: "Boho" },
        { value: "Rustikal", label: "Rustic" },
        { value: "Glamourös", label: "Glamorous" },
        { value: "Minimalistisch", label: "Minimalist" }
      ]
    },
    q11: {
      question: "What ambiance do you wish for?",
      options: [
        { value: "Rustikal", label: "Rustic" },
        { value: "Modern", label: "Modern" },
        { value: "Exotisch", label: "Exotic" },
        { value: "Royal", label: "Royal" }
      ]
    },
    q12: {
      question: "What is important to you about the location?",
      options: [
        { value: "Exklusiv", label: "Exclusivity" },
        { value: "Authentisch", label: "Authenticity" },
        { value: "Luxuriös", label: "Luxury" },
        { value: "Individuell", label: "Individuality" }
      ]
    },
    q13: {
      question: "What is important to you about accommodation?",
      options: [
        { value: "Luxus", label: "Luxury" },
        { value: "Komfort", label: "Comfort" },
        { value: "Charme", label: "Charm" },
        { value: "Praktisch", label: "Practical" }
      ]
    },
    q14: {
      question: "What type of accommodation do you prefer?",
      options: [
        { value: "Hotel", label: "Hotel" },
        { value: "Villa", label: "Villa" },
        { value: "Resort", label: "Resort" },
        { value: "Boutique", label: "Boutique" }
      ]
    },
    q15: {
      question: "Where is the focus on the wedding day besides the ceremony?",
      options: [
        { value: "Klassische_Feier", label: "Classic Celebration with Dinner & Dance" },
        { value: "Party_BBQ", label: "Party, Barbecue & Finger Food" },
        { value: "Gala", label: "Gala Dinner & Fireworks" },
        { value: "Intim", label: "Intimate Celebration & Solo Musician" }
      ]
    }
  },
  es: {
    q1: {
      question: "¿Cuándo planeas casarte?",
      options: [
        { value: "Januar-Februar", label: "Enero - Febrero" },
        { value: "März-April", label: "Marzo - Abril" },
        { value: "Mai-Juni", label: "Mayo - Junio" },
        { value: "Juli-August", label: "Julio - Agosto" },
        { value: "September-Oktober", label: "Septiembre - Octubre" },
        { value: "November-Dezember", label: "Noviembre - Diciembre" }
      ]
    },
    q2: {
      question: "¿Qué tan lejos estás dispuesto a viajar para tu boda?",
      options: [
        { value: "1", label: "Cerca (p. ej., Europa)" },
        { value: "2", label: "Medio (p. ej., Oriente Medio, Norte de África)" },
        { value: "3", label: "Lejos (p. ej., Asia, África)" },
        { value: "4", label: "Muy Lejos (p. ej., Américas, Oceanía)" }
      ]
    },
    q3: {
      question: "¿Qué aspectos culturales son importantes para ti?",
      options: [
        { value: "Kulinarik & Wein", label: "Culinaria y Vino" },
        { value: "Geschichte & Architektur", label: "Historia y Arquitectura" },
        { value: "Kunst & Design", label: "Arte y Diseño" },
        { value: "Spiritualität", label: "Espiritualidad" },
        { value: "Moderne Vibes", label: "Ambiente Moderno" }
      ]
    },
    q4: {
      question: "¿Qué clima prefieres?",
      options: [
        { value: "tropisch & warm", label: "Tropical y Cálido" },
        { value: "mediterran & mild", label: "Mediterráneo y Templado" },
        { value: "gemäßigt & kühl", label: "Templado y Fresco" },
        { value: "trocken & sonnig", label: "Seco y Soleado" },
        { value: "alpin & polar", label: "Alpino y Polar" }
      ]
    },
    q5: {
      question: "¿Qué escenario te atrae más?",
      options: [
        { value: "Strand", label: "Playa" },
        { value: "Regenwald", label: "Selva Tropical" },
        { value: "Berge", label: "Montañas" },
        { value: "City", label: "Ciudad" },
        { value: "Wüste", label: "Desierto" }
      ]
    },
    q6: {
      question: "¿Cuántos invitados esperas?",
      options: [
        { value: "zu_zweit", label: "Solo nosotros dos" },
        { value: "ca_15", label: "Aproximadamente 15 personas" },
        { value: "ca_25", label: "Aproximadamente 25 personas" },
        { value: "ca_40", label: "Aproximadamente 40 personas" },
        { value: "mehr_40", label: "Más de 40 personas" }
      ]
    },
    q7: {
      question: "¿Cuántos días debe durar la boda?",
      options: [
        { value: "1", label: "1 Día" },
        { value: "2", label: "2 Días" },
        { value: "3", label: "3 Días" },
        { value: "4", label: "4+ Días" }
      ]
    },
    q8: {
      question: "¿Cuál es tu rango de presupuesto?",
      options: [
        { value: "20_40k", label: "€20,000 - €40,000" },
        { value: "40_60k", label: "€40,001 - €60,000" },
        { value: "60_80k", label: "€60,001 - €80,000" },
        { value: "80_100k", label: "€80,001 - €100,000" },
        { value: "100k_plus", label: "€100,000 +" }
      ]
    },
    q9: {
      question: "¿Qué tipo de ceremonia prefieres?",
      options: [
        { value: "Freie_Trauung", label: "Ceremonia Libre" },
        { value: "Religiöse_Zeremonie", label: "Ceremonia Religiosa" },
        { value: "Standesamt", label: "Ceremonia Civil" },
        { value: "Symbolische_Zeremonie", label: "Ceremonia Simbólica" }
      ]
    },
    q10: {
      question: "¿Qué estilo de boda te queda bien?",
      options: [
        { value: "Elegant", label: "Elegante" },
        { value: "Boho", label: "Boho" },
        { value: "Rustikal", label: "Rústico" },
        { value: "Glamourös", label: "Glamoroso" },
        { value: "Minimalistisch", label: "Minimalista" }
      ]
    },
    q11: {
      question: "¿Qué ambiente deseas?",
      options: [
        { value: "Rustikal", label: "Rústico" },
        { value: "Modern", label: "Moderno" },
        { value: "Exotisch", label: "Exótico" },
        { value: "Royal", label: "Real" }
      ]
    },
    q12: {
      question: "¿Qué es importante para ti sobre la ubicación?",
      options: [
        { value: "Exklusiv", label: "Exclusividad" },
        { value: "Authentisch", label: "Autenticidad" },
        { value: "Luxuriös", label: "Lujo" },
        { value: "Individuell", label: "Individualidad" }
      ]
    },
    q13: {
      question: "¿Qué es importante para ti sobre el alojamiento?",
      options: [
        { value: "Luxus", label: "Lujo" },
        { value: "Komfort", label: "Comodidad" },
        { value: "Charme", label: "Encanto" },
        { value: "Praktisch", label: "Práctico" }
      ]
    },
    q14: {
      question: "¿Qué tipo de alojamiento prefieres?",
      options: [
        { value: "Hotel", label: "Hotel" },
        { value: "Villa", label: "Villa" },
        { value: "Resort", label: "Resort" },
        { value: "Boutique", label: "Boutique" }
      ]
    },
    q15: {
      question: "¿Dónde está el enfoque del día de la boda además de la ceremonia?",
      options: [
        { value: "Klassische_Feier", label: "Celebración Clásica con Cena y Baile" },
        { value: "Party_BBQ", label: "Fiesta, Barbacoa y Comida para Picar" },
        { value: "Gala", label: "Cena de Gala y Fuegos Artificiales" },
        { value: "Intim", label: "Celebración Íntima y Músico Solista" }
      ]
    }
  }
};

export const getQuestionTranslation = (questionId, lang = 'de') => {
  return questionTranslations[lang]?.[questionId] || questionTranslations['de'][questionId];
};
